export default __webpack_public_path__ + "media/images/theme/bg_dark-06db2561137faf4209b2024762ecad49.png";